import styled, { css } from 'styled-components'
import {
  BottomSheetProps,
  getWalletCouponChipsTxt,
} from 'src/components/layout/MainLayout/MainBottomSheet'
import * as React from 'react'
import { Container } from 'src/components/common/Container'
import { HorizontalDottedDivider } from 'src/components/common/Divider'
import barcodeBg from 'src/assets/images/main/open_wallet_barcode_bg.png'
import { useRef, useState } from 'react'
import useResizeEventListener from 'src/hooks/useResizeEventListener.hook'
import RenderIf from 'src/components/common/RenderIf'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body1_b16,
  Noto_body2_m14,
  Noto_body2_r14,
  Noto_body3_m12,
  Noto_body3_r12,
  Noto_desc_b10,
  Noto_heading3_b20,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Barcode } from 'src/components/common/Barcode'
import { Roboto_num2_b16 } from 'src/styles/fonts/RobotoFonts'
import { ellip } from 'src/styles/mixin'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { getBrandAndCouponName } from 'src/utils'
import { Spinner } from 'src/components/common/Spinner'
import { DateUtils } from 'src/utils/date'
import StarIcon from 'src/components/common/StarIcon'
import { Icon } from 'src/assets/svg/Icon'
import { ButtonOption3 } from 'src/components/common/Button'
import useDynamicHeight from 'src/hooks/useDynamicHeight.hook'
import coupon_thumbnail_default from 'src/assets/images/coupon_thumbnail/coupon_thumbnail_circle_default.png'
import useDynamicWidth from 'src/hooks/useDynamicWidth.hook'

const MEDIA_QUERY_WIDTH = 360
// 쿠폰 적정크키: 320px, 최소크키: 290px
// 바코드 적정높이: 176px, 작아진높이: 160px
const COUPON_HEIGHT = 186

const MainBottomSheetBody2 = (props: BottomSheetProps) => {
  const {
    walletCouponData,
    activeSwiperHandler: activeSwiperItems,
    walletCouponDataNoMore,
    setSwiperActiveIdxHandler: handleActiveSwiper,
    purchaseHistoryDetailPageNav,
    selfRegisterListPageNav,
    couponPurchaseHistoryPageNav,
    favoriteUpdateHandler,
    setTarget,
  } = props
  const { expiration7Days, getDayDifference, DateFormat } = DateUtils
  const { deviceWidth } = useDynamicWidth()
  const { deviceHeight } = useDynamicHeight()
  const isCouponEmpty = walletCouponData?.length === 0
  const isEmptyWalletCouponItems = walletCouponData?.length === 0 || !walletCouponData
  const topContentsRef = useRef<HTMLDivElement>(null)
  const middleContentsRef = useRef<HTMLDivElement>(null)
  const bottomContentsRef = useRef<HTMLDivElement>(null)

  const topClientHeight = () =>
    deviceHeight > 640 ? (topContentsRef?.current?.clientHeight as number) / 1.46 : 93

  const [barcodeSize, setBarcodeSize] = useState<number>(topClientHeight())

  const renderSpinner = (i: number) =>
    !walletCouponDataNoMore && !isEmptyWalletCouponItems && walletCouponData?.length - 1 === i

  useResizeEventListener(() => {
    setBarcodeSize(topClientHeight())
  }, activeSwiperItems)

  return (
    <S.MainBodyContainer $option="flex_column">
      {isCouponEmpty ? (
        <S.IsEmptyWalletCouponContainer $option="flex_column">
          <Typography $fontStyle={Noto_heading3_b20} $color={'var(--black-30)'}>
            쿠폰을 채워주세요.
          </Typography>
          <Typography $fontStyle={Noto_body2_m14} $color={'var(--black-50)'}>
            사용 가능한 쿠폰이 여기에 표시됩니다.
          </Typography>
        </S.IsEmptyWalletCouponContainer>
      ) : (
        <S.MainBottomSheetContainer $option="flex_column">
          {/*Top*/}
          <S.MainBottomSheetCouponContainer>
            <S.MainBottomSheetTop.Container $option="flex_column" $deviceWidth={deviceWidth}>
              {/*쿠폰 존재X*/}
              <RenderIf when={activeSwiperItems?.barcode === ''}>
                <S.MainBottomSheetTop.IsEmptyBarcode
                  $option="flex_column"
                  $deviceWidth={deviceWidth}
                >
                  <Typography $fontStyle={Noto_heading3_b20} $color="var(--black-30)">
                    쿠폰을 구매해주세요.
                  </Typography>
                  <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
                    [쿠폰 추가구매]를 눌러 <br />
                    간단하게 구매 할 수 있습니다.
                  </Typography>
                </S.MainBottomSheetTop.IsEmptyBarcode>
              </RenderIf>
              {/*쿠폰 존재O*/}
              <RenderIf when={activeSwiperItems?.barcode !== ''}>
                <S.MainBottomSheetTop.BarcodeWrap
                  $option="flex_column"
                  $deviceWidth={deviceWidth}
                  ref={topContentsRef}
                >
                  <S.MainBottomSheetTop.BarcodeContents $option="flex_column">
                    <RenderIf when={!isNaN(barcodeSize)}>
                      <React.Fragment>
                        <Barcode.Image
                          value={`${activeSwiperItems?.barcode}`}
                          barcode_height={barcodeSize}
                          style={S.MainBottomSheetTop.BarcodeImageStyle}
                        />
                        <Barcode.Text
                          value={`${activeSwiperItems?.barcode}`}
                          fontStyle={Roboto_num2_b16}
                          style={S.MainBottomSheetTop.BarcodeTextStyle}
                        />
                      </React.Fragment>
                    </RenderIf>
                  </S.MainBottomSheetTop.BarcodeContents>
                </S.MainBottomSheetTop.BarcodeWrap>
              </RenderIf>
            </S.MainBottomSheetTop.Container>
            <S.MainBottomSheetTop.DividerWrap>
              <HorizontalDottedDivider width="260px" />
            </S.MainBottomSheetTop.DividerWrap>
            {/*Middle*/}
            <S.MainBottomSheetMiddle.Container ref={middleContentsRef}>
              <CustomSwiper.Wrap type="creative" onActiveIndexChangeFn={handleActiveSwiper}>
                {walletCouponData?.map(
                  (
                    {
                      Idx,
                      CouponIdx,
                      CouponType,
                      CouponNumber,
                      CouponName,
                      BrandName,
                      ExpireDT,
                      CouponImage,
                      RegularPrice,
                      CouponCnt,
                    },
                    index: number,
                  ) => {
                    const purchaseHistoryNavHandler = () =>
                      purchaseHistoryDetailPageNav(Idx, CouponIdx, '0', CouponType, CouponNumber)

                    const unPurchasedCoupon = ExpireDT === ''
                    const selfRegisterCoupon = CouponType === 2
                    const chipsTxt = getWalletCouponChipsTxt(CouponType, CouponCnt)
                    return (
                      <CustomSwiper.Item $itemstyle={S.Swiper.Items(deviceWidth)} key={index}>
                        <S.Swiper.ItemsContainer $option="flex_row_space_between">
                          <S.CouponCard.Image src={CouponImage || coupon_thumbnail_default} />
                          <S.CouponCard.TextContainer $option="flex_column" $row_gap="10px">
                            <Container $option="flex_column">
                              <Typography
                                $fontStyle={Noto_body3_m12}
                                $color="var(--black-50)"
                                $style={S.CouponCard.BrandName}
                              >
                                {getBrandAndCouponName(CouponName).brandName || BrandName}
                              </Typography>
                              <Typography
                                $fontStyle={Noto_body2_r14}
                                $color="var(--black-100)"
                                $style={S.CouponCard.CouponName(unPurchasedCoupon)}
                              >
                                {getBrandAndCouponName(CouponName).couponName}
                              </Typography>
                              <Typography $fontStyle={Roboto_num2_b16} $color="var(--black-90)">
                                {selfRegisterCoupon ? '' : `${RegularPrice.toLocaleString()}원`}
                              </Typography>
                            </Container>
                            <RenderIf when={!unPurchasedCoupon || !!chipsTxt}>
                              <Container $option="flex_row" $column_gap={'6px'}>
                                <RenderIf when={!unPurchasedCoupon}>
                                  <Typography
                                    $fontStyle={Noto_body3_m12}
                                    $color={
                                      expiration7Days(ExpireDT)
                                        ? 'var(--black-70)'
                                        : 'var(--red-50)'
                                    }
                                  >
                                    D-{getDayDifference(ExpireDT, 'days')}
                                  </Typography>
                                  <Typography
                                    $fontStyle={Noto_body3_r12}
                                    $color={'var(--black-50)'}
                                  >
                                    {DateFormat(ExpireDT, 'YY.MM.DD')}
                                  </Typography>
                                </RenderIf>
                                <RenderIf when={!!chipsTxt}>
                                  <Typography
                                    $fontStyle={Noto_desc_b10}
                                    $style={S.CouponCard.CouponCnt(!!chipsTxt?.includes('보유중'))}
                                  >
                                    {chipsTxt}
                                  </Typography>
                                </RenderIf>
                              </Container>
                            </RenderIf>
                          </S.CouponCard.TextContainer>
                        </S.Swiper.ItemsContainer>
                        <RenderIf when={selfRegisterCoupon}>
                          <S.MainBottomSheetMiddle.DetailInfoButton
                            onClick={() => selfRegisterListPageNav(false)}
                          >
                            <Typography $fontStyle={Noto_body2_m14} $color="var(--black-60)">
                              쿠폰등록 관리
                            </Typography>
                          </S.MainBottomSheetMiddle.DetailInfoButton>
                        </RenderIf>
                        <RenderIf when={!unPurchasedCoupon && !selfRegisterCoupon}>
                          <S.MainBottomSheetMiddle.DetailInfoButton
                            onClick={purchaseHistoryNavHandler}
                          >
                            <Typography $fontStyle={Noto_body2_m14} $color="var(--black-60)">
                              쿠폰상세정보
                            </Typography>
                          </S.MainBottomSheetMiddle.DetailInfoButton>
                        </RenderIf>
                        <RenderIf when={renderSpinner(index)}>
                          <Container
                            $option="flex_row"
                            $style={S.MainBottomSheetMiddle.SpinnerDeem}
                          >
                            <Spinner $color="var(--black-10)" ref={setTarget} $margin="0 auto" />
                          </Container>
                        </RenderIf>
                      </CustomSwiper.Item>
                    )
                  },
                )}
              </CustomSwiper.Wrap>
            </S.MainBottomSheetMiddle.Container>
          </S.MainBottomSheetCouponContainer>
          <S.MainBottomSheetBottom.Container
            $option="flex_column"
            $deviceWidth={deviceWidth}
            ref={bottomContentsRef}
          >
            <Container $option="flex_row_space_between" $column_gap="6px">
              <RenderIf when={activeSwiperItems?.favorite !== undefined}>
                <StarIcon
                  size={48}
                  active={Boolean(activeSwiperItems?.favorite)}
                  bgColor="var(--black-80)"
                  onClickFn={favoriteUpdateHandler}
                />
              </RenderIf>
              <RenderIf when={!activeSwiperItems?.btnTxt}>
                <S.MainBottomSheetBottom.EmptyContainer />
              </RenderIf>
              <RenderIf when={!!activeSwiperItems?.btnTxt}>
                <S.MainBottomSheetBottom.SwiperActionButton onClick={activeSwiperItems?.func}>
                  <Typography $fontStyle={Noto_body1_b16}>{activeSwiperItems?.btnTxt}</Typography>
                </S.MainBottomSheetBottom.SwiperActionButton>
              </RenderIf>
            </Container>
            {/*직접등록쿠폰시에 숨김*/}
            <Container
              $option="flex_row"
              $style={S.BodyBottomNav}
              onClick={couponPurchaseHistoryPageNav}
            >
              <Typography $fontStyle={Noto_body2_m14} $color="var(--black-30)">
                {activeSwiperItems?.chipsTxt !== '직접등록' ? '전체 구매내역 보러가기' : '\u00A0'}
              </Typography>
              <RenderIf when={activeSwiperItems?.chipsTxt !== '직접등록'}>
                <Icon.Arrow size="16" rotate="right" color="var(--black-30)" />
              </RenderIf>
            </Container>
          </S.MainBottomSheetBottom.Container>
        </S.MainBottomSheetContainer>
      )}
    </S.MainBodyContainer>
  )
}

export default MainBottomSheetBody2

const S = {
  MainBodyContainer: styled(Container)`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  `,
  IsEmptyWalletCouponContainer: styled(Container)`
    justify-content: center;
    align-items: center;
    margin: 0 20px;
    width: calc(100% - 40px);
    height: calc(100% - 20px);
    border-radius: 24px;
    border: 1px solid var(--brand-70);
    box-shadow: 0 2px 6px 0 rgba(0, 131, 252, 0.4);
    gap: 4px;
  `,
  MainBottomSheetContainer: styled(Container)``,
  MainBottomSheetCouponContainer: styled(Container)`
    margin: 25px 0;
  `,
  MainBottomSheetTop: {
    Container: styled(Container)<{ $deviceWidth: number }>`
      margin: 0 auto;
      position: relative;
      width: ${(props) => (props.$deviceWidth > MEDIA_QUERY_WIDTH ? '320px' : '290px')};
    `,
    BarcodeWrap: styled(Container)<{ $deviceWidth: number }>`
      height: auto;
      background: url(${barcodeBg}) no-repeat center/cover;

      &:after {
        content: '';
        padding-top: ${(props) => (props.$deviceWidth > MEDIA_QUERY_WIDTH ? '176px' : '160px')};
        display: flex;
      }
    `,
    BarcodeContents: styled(Container)`
      position: absolute;
      top: 0;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    `,
    BarcodeImageStyle: css`
      padding: 12px;
      height: 120px;
    `,
    BarcodeTextStyle: css`
      width: 100%;
      text-align: center;
      padding: 0 20px 16px;
    `,
    IsEmptyBarcode: styled(Container)<{ $deviceWidth: number }>`
      justify-content: center;
      text-align: center;
      height: ${(props) => (props.$deviceWidth > MEDIA_QUERY_WIDTH ? '176px' : '160px')};
      max-width: 320px;
      max-height: 176px;
      min-height: 137px;
      gap: 4px;
      border-radius: 24px;
      border: 1px solid var(--brand-70);
      background: var(--black-90);
      box-shadow: 0 2px 6px 0 rgba(0, 131, 252, 0.4);
    `,
    DividerWrap: styled(Container)`
      display: flex;
      justify-content: center;
      margin: 10px 0;
    `,
  },
  MainBottomSheetMiddle: {
    Container: styled(Container)``,
    SpinnerDeem: css`
      position: absolute;
      top: 0;
      left: 0;
      height: ${COUPON_HEIGHT}px;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.7);
    `,
    DetailInfoButton: styled.button`
      margin-top: 14px;
      width: 100%;
      height: 38px;
      border-radius: 8px;
      border: 1px solid var(--black-10);
    `,
  },
  CouponCard: {
    Image: styled.img`
      width: 72px;
      height: 72px;
      margin: 0;
      border-radius: 100px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      object-fit: contain;
      background-color: var(--white);
    `,
    BrandName: css`
      ${ellip('line1')};
    `,
    CouponName: (lineExpansion: boolean) => css`
      ${ellip(lineExpansion ? 'line2' : 'line1')};
      margin: 4px 0;
      line-height: 18px !important;
    `,
    TextContainer: styled(Container)`
      max-width: calc(100% - 84px); /* image72px + gap12px */
    `,
    CouponCnt: (isRed: boolean) => css`
      border-radius: 100px;
      padding: 2px 8px;
      background-color: ${isRed ? 'var(--red-10)' : 'var(--brand-10)'};
      color: ${isRed ? 'var(--red-30)' : 'var(--brand-50)'};
    `,
  },
  Swiper: {
    Wrap: css``,
    Items: (deviceWidth: number) => css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
      width: ${deviceWidth > MEDIA_QUERY_WIDTH ? '320px' : '290px'};
      height: ${COUPON_HEIGHT}px;
      background-color: var(--white);
      border-radius: 24px;
    `,
    ItemsContainer: styled(Container)`
      flex: 1;
      max-width: 280px;
      width: 100%;
      align-items: center;
      gap: 12px;
    `,
  },
  MainBottomSheetBottom: {
    Container: styled(Container)<{ $deviceWidth: number }>`
      max-width: 360px;
      min-width: 320px;
      margin: 0 auto;
      padding: ${(props) =>
        props.$deviceWidth > 340 ? '0 20px' : '0 15px'}; /* min(320) max(360) 중간기준 */
      width: 100%;
    `,
    EmptyContainer: styled(Container)`
      height: 48px;
    `,
    SwiperActionButton: styled.button`
      ${ButtonOption3('active')}
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    `,
  },
  BodyBottomNav: css`
    margin: 20px auto 0 auto;
    text-align: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: fit-content;
  `,
}
